import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import { ValidationError } from '../../components';
import TimePicker from '../TimePicker/TimePicker';
import css from './FieldTimePicker.module.css';

const FieldTimePickerComponent = props => {
    const {
        rootClassName,
        className,
        id,
        label,
        input,
        meta,
        ...rest
    } = props;

    const { touched, invalid, error } = meta;
    const hasError = touched && invalid && error;

    const inputClassName = classNames({
        [css.inputError]: hasError,
    });

    const classes = classNames(rootClassName || css.root, className);

    return (
        <div className={classes}>
            {label ? (
                <label htmlFor={id} className={css.label}>
                    {label}
                </label>
            ) : null}
            <TimePicker
                id={id}
                inputClassName={inputClassName}
                {...input}
                {...rest}
            />
            <ValidationError fieldMeta={meta} />
        </div>
    );
};

FieldTimePickerComponent.defaultProps = {
    rootClassName: null,
    className: null,
    id: null,
    label: null,
    input: {},
    meta: {},
};

FieldTimePickerComponent.propTypes = {
    rootClassName: PropTypes.string,
    className: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string,
    input: PropTypes.object,
    meta: PropTypes.object,
};

const FieldTimePicker = props => {
    return <Field component={FieldTimePickerComponent} {...props} />;
};

export default FieldTimePicker;
